import { $one } from "./querySelector"

/*
Open nodes with CSS and dataset

  Accepts:
  - node: {String} query selector who detect click
  - parent: {String} query selector with the node to open
  - config: {Object} Obejct with attribute from config open

  Usage:
  - toggleDataActive('#btn-search', '#search');

  else if, you open the same node
  - toggleDataActive('#btn-search');

*/

const overlayActions = ({ isActive, target }) => {
  const id = target.getAttribute('id')

  if (!isActive) {
    const before = document.createElement('div')
    before.setAttribute('id', `overlay--${id}`)
    before.classList.add('overlay')
    target.parentNode.insertBefore(before, target)
    toggleDataActive(
      `#overlay--${id}`,
      `#${id}`,
      { overlay: true }
    )
  } else {
    target.parentNode.removeChild($one(`#overlay--${id}`))
  }
}
export function dataToggle (nodeToOpen, overlay) {
  const dataset = nodeToOpen.dataset.active
  const isActive = dataset != 'true' ? false : true
  
  if (!dataset) return null

  if (!isActive) {
    nodeToOpen.dataset.active = 'true'
  } else {
    nodeToOpen.dataset.active = 'false'
  }

  overlay && overlayActions({ 
    isActive,
    target: nodeToOpen
  })
}

export const toggleDataActive = (node, parent, config) => {
  const { overlay } = config ? config : { overlay: false }
  const toOpen = parent ? $one(parent) : $one(node)

  return $one(node).addEventListener(
    'click',
    function () {
      dataToggle(toOpen, overlay)
    }
  )
}

/* const closestAll = (nodeToOpen, eventNode) => {
  document.addEventListener('click', function (e) {

    const toClosest = e.target.closest('[data-active="true"]')
    const fromEvent = e.target.closest(eventNode)
    const isActive = nodeToOpen.dataset.active
  
    if (isActive !== 'true') return null
  
    if (!toClosest && !fromEvent) {
      nodeToOpen.dataset.active = 'false'
    }

  })
} */
